import React from 'react';
import { useDispatch } from 'react-redux';
import { showModal } from 'store/slices/miscSlice';
import { addBranch } from 'pages/Settings/redux/Types';
import AddBranch from './AddBranch';
import HeaderComponent from 'components/HeaderComponent';
import { BranchValidation } from 'pages/Settings/validation';
import { withTranslation } from 'react-i18next';
import usePermissions from 'hooks/usePermissions';

export default withTranslation()(function BranchHeader({ t }) {
  const dispatch = useDispatch();

  const { isPermitted } = usePermissions()
  return (
    <HeaderComponent
      title={t('settings.branch.table.title')}
      btnText={t('settings.branch.add')}
      hideBtn={!isPermitted?.create_branches}
      btnClick={
        () => dispatch(
          showModal({
            title: t('settings.branch.add'),
            content: AddBranch,
            dispatchAction: addBranch, action: (data) => console.log(data, 'add'),
            url: 'merchants/branches',
            values: {},
            method: 'post',
            validation: BranchValidation,
            successMsg: t('settings.branch.form.success')
          })
        )}
    // showSearch={true}
    />
  )
})
